import { FULL_MONTHS, MONTHS } from 'helpers/dateHelper';
import { DashDateString, DateString } from './types';

/**
 * Transforms a Date object to a dashed date string representation (2023-11-04)
 */
export const dateToDashDateString = (date: Date): DashDateString => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}` as DashDateString;
};

/**
 * Transforms a dashed date to a Date object
 */
export const dashDateStringToDate = (dateStr: DashDateString): Date => {
    return new Date(dateStr);
};

/**
 * Transforms a date to a Date object
 */

export const dateStringToDate = (dateStr: DateString): Date => {
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    return new Date([year, month, day].join('-'));
};

/**
 * Transforms date strings (20231104) to dashed date strings (2023-11-04)
 */
export const dateStringToDashDateString = (
    date: DateString,
): DashDateString => {
    const dashDate = date.split('');
    dashDate.splice(4, 0, '-');
    dashDate.splice(7, 0, '-');
    return dashDate.join('') as DashDateString;
};

/**
 * Transforms dash date strings (2023-11-04) to a string with month and year
 * in french (novembre 2023).
 * @param dateStr Date to format
 * @param useShort If true, format uses short versions of months. Ex: Nov. instead of Novembre
 * @returns
 */
export const dashDateStringToMonth = (
    dateStr: DashDateString,
    useShort: boolean = false,
) => {
    const date = new Date(dateStr);
    const months = useShort ? MONTHS.map((m) => `${m}.`) : FULL_MONTHS;
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const getLastYearDateString = (dateString: DateString): string => {
    const year = dateString.substring(0, 4);
    const monthAndDay = dateString.substring(4);
    const newYear = (parseInt(year, 10) - 1).toString();

    return newYear + monthAndDay;
};
/**
 * Transforms date strings (20231104) to a string with month and year
 * in french (novembre 2023).
 * @param dateStr Date to format
 * @param useShort If true, format uses short versions of months. Ex: Nov. instead of Novembre
 * @returns
 */
export const dateStringToMonth = (
    dateStr: DateString,
    useShort: boolean = false,
) => {
    const date = new Date(dateStringToDashDateString(dateStr));
    const months = useShort ? MONTHS.map((m) => `${m}.`) : FULL_MONTHS;
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
};
